import React from 'react'
import { Modal } from 'react-bootstrap'

// Read-only Safety Systems view for the Client Portal. Safety system items are
// not editable here (that happens in the Admin Portal) — this simply shows
// which safety systems are Equipped vs Optional.
const SafetySystemsModal = ({ show, onHide, report }) => {
  const safetyFeatures = report.safetyFeatures || []
  const selectedTrim = (report.vehicle && report.vehicle.trim) || null
  const hasTrimData = safetyFeatures.some(f => ((f.trimAvailabilities || []).length > 0))
  const applyTrimFilter = selectedTrim && hasTrimData

  const editedFeatures = safetyFeatures
    .map((feature) => {
      if (!applyTrimFilter) {
        return feature
      }

      const availability = (feature.trimAvailabilities || []).find(
        ta => ta.trim === selectedTrim
      )

      if (!availability) return null
      return { ...feature, category: availability.availability }
    })
    .filter(Boolean)

  const equipped = editedFeatures.filter(feature => feature.category === 'equipped')
  const optional = editedFeatures.filter(feature => feature.category !== 'equipped')

  const Column = ({ title, items, equipped }) => (
    <div className='adas-safety-column'>
      <h6 className='adas-safety-column-title'>{title}</h6>
      {items.length ? (
        items.map(feature => (
          <div key={feature.id || feature.name} className='adas-safety-row-readonly'>
            <span>{feature.name || 'Safety System'}</span>
            {equipped ? (
              <span className='adas-safety-equipped-badge'>Equipped</span>
            ) : (
              <span className='adas-safety-select-badge'>Select</span>
            )}
          </div>
        ))
      ) : (
        <p className='adas-safety-empty'>None</p>
      )}
    </div>
  )

  return (
    <Modal show={show} onHide={onHide} centered size='lg' dialogClassName='adas-safety-modal'>
      <button className='adas-modal-close' onClick={onHide} aria-label='Close'>&times;</button>
      <Modal.Body>
        <h3 className='adas-modal-title'>Safety Systems</h3>
        <p className='adas-modal-copy'>Identify the safety systems that are equipped on this vehicle.</p>
        <div className='adas-safety-grid'>
          <Column title='Equipped' items={equipped} equipped />
          <Column title='Optional' items={optional} />
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default SafetySystemsModal
